import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { HotelService } from 'src/app/services/hotel.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { colorObj } from 'src/shared/color-object';
import { PopupComponent } from '../../popup/popup.component';
import { ReCaptchaV3Service } from 'ng-recaptcha';
declare const Calendly: any;

@Component({
  selector: 'app-blog10',
  templateUrl: './blog10.component.html',
  styleUrls: ['./blog10.component.css']
})
export class Blog10Component {
  contactUsForm: FormGroup;
  emailPattern = environment.EMAIL_PATTERN;
  disabled: boolean = false;
  mobile: boolean = false;
  showStickyOverview: boolean = true;
  activeSection: string = '';
  isPopupOpen: boolean = false;
  public calendlyUrl = environment.CALENDLY_URL;
  @ViewChild('faqSection') faqSectionRef!: ElementRef;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenWidth();
  }
  faqs = [
    {
      question: 'What role does CRM play in improving hotel booking management?',
      answer: 'CRM software centralizes all booking data, helping hotels streamline the reservation process and manage guest preferences effectively.',
      open: false
    },
    {
      question: 'How does CRM software help hotels manage customer feedback effectively?',
      answer: 'By collecting and analyzing guest feedback, CRM software enables hotels to respond promptly and make data-driven improvements.',
      open: false
    },
    {
      question: 'What are the financial benefits of implementing a CRM system in hotels?',
      answer: 'CRM systems help increase revenue by improving guest satisfaction, promoting repeat bookings, and automating upselling opportunities.',
      open: false
    },
    {
      question: 'How can hotels use CRM data to increase guest loyalty and repeat bookings?',
      answer: 'By personalizing services based on CRM data, hotels can enhance guest experiences, leading to increased loyalty and repeat visits.',
      open: false
    },
    {
      question: 'What are common challenges hotels face when integrating CRM systems?',
      answer: 'Challenges may include data migration, staff training, and ensuring seamless integration with existing hotel management systems.',
      open: false
    },
    {
      question: 'How can CRM software improve communication between hotel departments?',
      answer: 'CRM software centralizes guest data, enabling departments to access real-time information, improving collaboration and service delivery.',
      open: false
    }
  ];
  articles = [
    {
      title: 'how to travel cheaper: insider tips for affordable adventures',
      text: 'Apart from being one of the best activities during a vacation, travel can...',
      image: 'assets/images/Travel-Cheaper-image.png',
      readTime: '7 Minutes Read',
      onClick: () => this.viewTravelCheaper()
    },
    {
      title: 'what’s the difference between hotel and motel',
      text: 'When planning your next trip, it is necessary to understand the difference...',
      image: 'assets/images/hotel-and-motel-image.png',
      readTime: '7 Minutes Read',
      onClick: () => this.viewHotelAndMotel()
    },
    {
      title: 'Step-by-step guide: how to start a travel agency',
      text: 'Business Opportunities in Travel and Tourism for the Passionate Traveler has...',
      image: 'assets/images/travel-agency-image.png',
      readTime: '5 Minutes Read',
      onClick: () => this.viewTravelAgency()
    }
  ]

  toggleFAQ(faq: any) {
    faq.open = !faq.open;
  }

  constructor(
    private hotelService: HotelService,
    private notify: NotificationService,
    private router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    this.contactUsForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(200)]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      message: ['', Validators.required],
      tnc: ['', Validators.required]
    })
  }

  ngOnInit(): void {
    this.checkScreenWidth();
  }

  ngAfterViewInit(): void {
    this.route.fragment.subscribe((fragment: string | null) => {
      if (fragment) {
        setTimeout(() => this.scrollToSection(fragment), 0);
      }
    });
  }

  private checkScreenWidth() {
    if (window.innerWidth <= 1250) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.updateActiveSection();
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const faqSectionTop = this.faqSectionRef.nativeElement.offsetTop;
    const threshold2 = 530;
    if (!this.isPopupOpen) {
      this.showStickyOverview = scrollPosition < (faqSectionTop - threshold2);
    } else {
      this.showStickyOverview = false;
    }
  }

  private updateActiveSection() {
    const sections = [
      'CRM-Software',
      'Hotel-CRM-Features',
      'Hotel-CRM-Benefits',
      'How-To-Choose-CRM',
      'Why-Choose-GoFryDay',
      'Conclusion'
    ];
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    let currentActiveSection: string = '';
    for (const sectionId of sections) {
      const section = document.getElementById(sectionId);
      if (section) {
        const sectionTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
        const sectionBottom = sectionTop + section.offsetHeight;
        if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
          currentActiveSection = sectionId;
          break;
        }
      }
    }
    if (this.activeSection !== currentActiveSection) {
      this.activeSection = currentActiveSection;
    }
  }

  openCalendlyPopup() {
    Calendly.initPopupWidget({ url: this.calendlyUrl });
    return false;
  }

  viewLinkedIn() {
    const linkedInUrl = environment.LINKEDIN_URL;
    const websiteUrl = `${environment.WEBSITE_URL}/blog/benefits-of-crm-in-hotel-industry`;
    const fullUrl = `${linkedInUrl}${websiteUrl}`;
    window.open(fullUrl, "_blank");
  }

  backButton() {
    this.router.navigateByUrl('blog');
    window.scrollTo(0, 0);
  }

  submitContactForm() {
    if (this.contactUsForm.invalid) {
      return;
    }
    this.disabled = true;
    this.isPopupOpen = true;
    this.recaptchaV3Service.execute('contactFormSubmit').subscribe({
      next: (token) => {
        let obj = {
          "NAME": this.contactUsForm.value.name,
          "EMAIL": this.contactUsForm.value.email,
          "MESSAGE": this.contactUsForm.value.message,
          "TNC": true
        };

        this.hotelService.contactUs(obj, token).subscribe({
          next: (data) => {
            this.disabled = false;
            if (!!data?.object?.ID) {
              const dialogRef = this.dialog.open(PopupComponent, {
                width: '50%',
                data: { name: 'contact-us', message: 'Thank you for reaching out to us! We will connect with you shortly.' },
                disableClose: true
              });
              dialogRef.afterClosed().subscribe(() => {
                this.isPopupOpen = false;
              });
            } else {
              this.notify.showNotification(
                data.message,
                "top",
                (!!colorObj[data.status] ? colorObj[data.status.status] : "success"),
                data.status
              );
            }
            this.contactUsForm.reset();
          },
          error: (e) => {
            this.disabled = false;
            this.contactUsForm.reset();
            this.notify.showNotification(
              e.error.message,
              "top",
              (!!colorObj[e.error.status] ? colorObj[e.error.status] : "error"),
              e.error.status
            )
          }
        })
      },
      error: () => {
        this.disabled = false;
        this.contactUsForm.reset();
        this.notify.showNotification(
          'reCAPTCHA verification failed. Please try again.',
          "top",
          "error",
          500
        );
      }
    });
  }


  viewTravelCheaper() {
    this.router.navigateByUrl('blog/how-to-travel-cheap');
    window.scrollTo(0, 0);
  }

  viewHotelAndMotel() {
    this.router.navigateByUrl('blog/difference-between-hotel-and-motel');
    window.scrollTo(0, 0);
  }

  viewTravelAgency() {
    this.router.navigateByUrl('blog/how-to-start-a-travel-agency');
    window.scrollTo(0, 0);
  }

  viewPrivacyPolicy() {
    window.open('privacy-policy', "_blank");
  }

  viewTermsConditions() {
    window.open('terms-conditions', "_blank");
  }

  viewCRMSoftware() {
    this.scrollToSection('CRM-Software');
  }

  viewHotelCrmFeatures() {
    this.scrollToSection('Hotel-CRM-Features');
  }

  viewHotelCrmBenefits() {
    this.scrollToSection('Hotel-CRM-Benefits');
  }

  viewHotelCrmChoose() {
    this.scrollToSection('How-To-Choose-CRM');
  }

  viewWhyChooseGoFryDay() {
    this.scrollToSection('Why-Choose-GoFryDay');
  }

  viewConclusion() {
    this.scrollToSection('Conclusion');
  }


  scrollToSection(sectionId: string) {
    this.activeSection = sectionId;
    const section = document.getElementById(sectionId);
    if (section) {
      const yOffset = -80;
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

}
